import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import './assets/main.css'

const app = createApp(App)

// Register global components asynchronously to reduce initial JS parse/execute
app.component(
  'AudioController',
  defineAsyncComponent(() => import('./components/AudioController.vue'))
)
app.component(
  'CustomInput',
  defineAsyncComponent(() => import('./components/CustomInput.vue'))
)
app.component(
  'CustomButton',
  defineAsyncComponent(() => import('./components/CustomButton.vue'))
)
app.component(
  'MultiSelectDropdown',
  defineAsyncComponent(() => import('./components/MultiSelectDropdown.vue'))
)
app.component(
  'Info',
  defineAsyncComponent(() => import('./components/Info.vue'))
)

// Flowbite components as async to keep them out of the initial chunk
app.component(
  'FwbSelect',
  defineAsyncComponent(() => import('flowbite-vue').then((m) => m.FwbSelect))
)
app.component(
  'FwbInput',
  defineAsyncComponent(() => import('flowbite-vue').then((m) => m.FwbInput))
)
app.component(
  'FwbButton',
  defineAsyncComponent(() => import('flowbite-vue').then((m) => m.FwbButton))
)

app.use(createPinia())
app.use(router)
app.mount('#app')
